import {useEffect} from "react"
import {BrowserRouter,Routes,Route,useLocation} from "react-router-dom"
import Navbar from "./components/Navbar"
import Footer from "./components/Footer"
import Copyright from "./components/Copyright"
import Home from "./pages/Home"
import Career from "./pages/Career"
import Contact from "./pages/Contact"
import ERP from "./pages/ERP"
import WebDev from "./pages/WebDev"
import Training from "./pages/Training"

function RouteScroll(){
 const {pathname,hash}=useLocation()

 useEffect(()=>{
  if(hash){
   const section=document.querySelector(hash)

   if(section){
    section.scrollIntoView({behavior:"smooth",block:"start"})
   }

   return
  }

  window.scrollTo({top:0,behavior:"smooth"})
 },[pathname,hash])

 return null
}

function App(){
 return(
  <BrowserRouter>
   <RouteScroll/>
   <Navbar/>

   <Routes>
    <Route path="/" element={<Home/>}/>
    <Route path="/career" element={<Career/>}/>
    <Route path="/contact" element={<Contact/>}/>
    <Route path="/erp" element={<ERP/>}/>
    <Route path="/webdev" element={<WebDev/>}/>
    <Route path="/training" element={<Training/>}/>
   </Routes>

   <Footer/>
   <Copyright/>
  </BrowserRouter>
 )
}

export default App
